export const DocumentTitleChange = (title) => {
    document.title = title ? `Vinga${" "}|${" "}${title}` : "";
  };